import {defineMessages} from 'react-intl';

import type {RepaymentLogColumns} from './types';

export const repaymentLogLocalizedHeaders = defineMessages<RepaymentLogColumns>({
    repaymentDate: {
        id: 'repaymentLogLocalizedHeaders_repaymentDate',
        defaultMessage: 'Repayment Date',
    },
    masterAgentUid: {
        id: 'repaymentLogLocalizedHeaders_masterAgentUid',
        defaultMessage: 'Master Agent ID',
    },
    masterAgentUsername: {
        id: 'repaymentLogLocalizedHeaders_masterAgentUsername',
        defaultMessage: 'Master Agent Username',
    },
    fromAgentUid: {
        id: 'repaymentLogLocalizedHeaders_fromAgentUid',
        defaultMessage: 'From Agent ID',
    },
    fromAgentUsername: {
        id: 'repaymentLogLocalizedHeaders_fromAgentUsername',
        defaultMessage: 'Agent Username',
    },
    repaymentAmount: {
        id: 'repaymentLogLocalizedHeaders_repaymentAmount',
        defaultMessage: 'Repayment Amount',
    },
    edit: {
        id: 'repaymentLogLocalizedHeaders_edit',
        defaultMessage: 'Edit',
    },
    remove: {
        id: 'repaymentLogLocalizedHeaders_remove',
        defaultMessage: 'Remove',
    },
});
